<script>
    import {createEventDispatcher} from "svelte";
    const dispatch = createEventDispatcher();

    export let total;
    export let showTotal = true;
    export let publishConfig = {};

    function openCartScreen () {
        dispatch('openCartScreen');
    }

</script>

<style>

    .cart-wd-container {
        display: flex;
        justify-content: center;
        position: fixed;
        width: 100vw;
        bottom: 1rem;
    }
    .cart-wd {
        white-space: nowrap;
        background: var(--cart-widget-color);
        color: white;
        padding: 0.5rem 0.75rem;
        border-radius: 2rem;
        border: 1px solid transparent;
        box-shadow: 0 4px 8px 0 #1a1f5185;
        line-height: 1;
        gap: .5rem;
    }
    .cost {
        border-left: 1px solid #555555;
        margin-left: 0.25rem;
        padding-left: 0.75rem;
    }
</style>

{#if (total?.count > 0)}
<div class="cart-wd-container layer-widgets">
    <div class="cart-wd ai-center" on:click={openCartScreen}>
        <span>Заказ:</span>
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Coffee"><path d="M11 7c4.418 0 8 .895 8 2s-3.582 2-8 2-8-.895-8-2c0-.357.375-.693 1.033-.984"/><path d="M3 9v9.343c0 1.061.44 2.08 1.409 2.513C5.624 21.399 7.711 22 11 22c3.29 0 5.377-.601 6.591-1.144.968-.433 1.409-1.452 1.409-2.513V9"/><path d="M19 10v0a3 3 0 0 1 3 3v0a3 3 0 0 1-3 3v0"/><path d="M7 3v4"/><path d="M11 2v2"/><path d="M15 4v3"/></svg>
        </span>
        <span>
            <svg xmlns="http://www.w3.org/2000/svg" width=".5em" height=".5em" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="ai ai-Cross"><path d="M20 20L4 4m16 0L4 20"/></svg>
        </span>
        <span>{ total.count }</span>

        {#if (showTotal)}
        <span class="cost">
            {#if (publishConfig.currency)}
            <span>{publishConfig.currency} </span>
            {/if}
            { total.sum }
        </span>
        {/if}
    </div>
</div>
{/if}
